import styled from 'styled-components';

import { SpinnerIcon } from 'components/ui/icons';

import { BODY_TEXT } from 'styles/color';

const DEFAULT_SPINNER_SIZE = 15;

const SpinnerContainer = styled.div<{ $size: number }>`
  align-items: center;
  animation: rotate 2s linear infinite;
  display: flex;
  height: ${({ $size }) => `${$size}px`};
  justify-content: center;

  /*
   * The container is 1px larger than the SpinnerIcon so the rotation transform-origin stays centered
   * (legacy IE fix, kept harmless). A width, height, & viewBox must be present on the svg to avoid scaling issues.
   */
  width: ${({ $size }) => `${$size}px`};

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

/**
 * Generic spinner.
 *
 * @param fill - Icon color; defaults to the body text color.
 * @param size - Square box size in px; the icon renders 1px smaller. Defaults to 15.
 */
const Spinner = ({ fill = BODY_TEXT, size = DEFAULT_SPINNER_SIZE, ...props }) => (
  <SpinnerContainer $size={size} {...props}>
    <SpinnerIcon fill={fill} height={`${size - 1}px`} width={`${size - 1}px`} />
  </SpinnerContainer>
);

export default Spinner;
